import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .copy-content {
    background-color: #fbfbfb;
    border: 1px solid #dbdde2;
    margin: 0;
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
  }
`;

export const StyledCreateVideo = styled.div`
  .create-new-title {
    color: #0b1a30;
    font-size: 20px;
    margin: 0;
    padding-bottom: 16px;
    font-weight: 500;
  }
  .create-new-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    height: 152px;
    border-radius: 1px;
    background-color: #fbfbfb;
    border: 1px solid #f4f4f4;
    margin-bottom: 40px;
    @media only screen and (max-width: 768px) {
      flex-direction: column;
    }
  }
`;
